import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { UserInfoRequestGestorPageRoutingModule } from "./user-info-request-gestor-routing.module";
import { UserInfoRequestGestorPage } from "./user-info-request-gestor.page";
import { AddAddressPageModule } from "../../../shared/components/v2/add-address/add-address.module";
import { SharedModule } from "../../../shared/shared.module";
import { IonMaskModule } from "../../../shared/directives/ion-mask/ion-mask.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    UserInfoRequestGestorPageRoutingModule,
    AddAddressPageModule,
    SharedModule,
    IonMaskModule,
  ],
  declarations: [UserInfoRequestGestorPage],
  exports: [UserInfoRequestGestorPage],
})
export class UserInfoRequestGestorPageModule {}
